<template>
    <Doughnut
      :chart-options="chartOptions"
      :chart-data="chartData"
      :chart-id="chartId"
      :dataset-id-key="datasetIdKey"
      :plugins="plugins"
      :css-classes="cssClasses"
      :styles="styles"
      :width="width"
      :height="height"
    />
  </template>
  
  <script>
  import { Doughnut } from 'vue-chartjs/legacy'
  
  import {
    Chart as ChartJS,
    Title,
    Tooltip,
    Legend,
    ArcElement,
    CategoryScale
  } from 'chart.js'
  
  ChartJS.register(Title, Tooltip, Legend, ArcElement, CategoryScale)
  
  export default {
    name: 'DoughnutChart',
    components: {
      Doughnut
    },
    props: {
      chartId: {
        type: String,
        default: 'doughnut-chart'
      },
      datasetIdKey: {
        type: String,
        default: 'label'
      },
      width: {
        type: Number,
        default: 400
      },
      height: {
        type: Number,
        default: 400
      },
      cssClasses: {
        default: '',
        type: String
      },
      styles: {
        type: Object,
        default: () => {}
      },
      plugins: {
        type: Array,
        default: () => []
      }
    },
    data() {
      return {
        chartData: {
          // labels: ['VueJs', 'EmberJs', 'ReactJs', 'AngularJs'],
          // datasets: [
          //   {
          //     backgroundColor: ['#41B883', '#E46651', '#00D8FF', '#DD1B16'],
          //     data: [40, 20, 80, 10]
          //   }
          // ]
        },
        chartOptions: {
          responsive: true,
          maintainAspectRatio: false,
          cutout: '62%',
          plugins: {
            // 2026-10-06：页面已经固定列出全部名称、数量和占比，隐藏图内图例可避免
            // 版本较多时挤压圆环；悬停提示仍保留，例：3.9.16: 120 (4.25%)。
            legend: {
              display: false
            },
            tooltip: {
              callbacks: {
                label(context) {
                  const values = context.dataset.data || []
                  const total = values.reduce((sum, value) => sum + Number(value || 0), 0)
                  const value = Number(context.raw || 0)
                  const percent = total > 0 ? (value * 100 / total).toFixed(2) : '0.00'
                  return `${context.label}: ${value.toLocaleString('zh-CN')} (${percent}%)`
                }
              }
            }
          }
        }
      }
    },
    methods:{
      setData(data){
        this.chartData = data;
      }
    }
  }
  </script>
